module.exports = __webpack_public_path__ + "img/icon209.5f280de3.png";